import axios from 'axios';
import config from "../config";
const AbraApiModule = config.API_URL+'/storecards';
const DiscogsApiModule = config.DISCOGS_API_URL+'/database/search';
import authHeader from './auth.header';

const querySearch = {
    "class": "storecards",
    "select": [
      "ID",
      "ClassID", 
      "Code",
      "Name", 
      "DisplayName", 
      "ObjVersion",
      {
        "name":"StoreMenuItem_ID",
        "value": [
          "Text"
        ]
      },
      {
        "name": "X_Interpret_ID",
        "value": [
          "FullName"
        ]
      },
      {
        "name": "X_Publisher_ID",
        "value": [
          "Name"
        ]
      },
      { 
        "name":"Picture_ID",
        "value": [
          "DisplayName",
          "ID",
          "PictureTitle",
          "ExternalFile",
          "PathAndFileName"
        ]
      },
      "X_DateOfPublication",
      "CreatedAt$DATE",
      "X_Price",
      "ShortName",
      "Comment",
      "EAN",
      "Specification2",
      "X_PublishEshop",
      "X_Quantity",
      "X_LastSale$DATE",
      "X_LastSalePrice",
      "X_CoverNumbers"
    ],
    "where": ["Hidden = false and StoreCardCategory_ID = '1000000101'"],
}
// "where": ["Hidden = false and X_PublishEshop = 'A' and X_CoverNumbers <> ''"]

// export class StoreCard {
//   "DisplayName": String | null;
//   "ID": String | null;
//   "DateOfChange": String | null;
//   "ClassID": String | null,
//   "ObjVersion": Number | 0;
//   "StoreUnits"?: Array<StoreUnits>
// }

// export class StoreUnits {
//         "DisplayName": String;
//         "EAN": String;
//         "StoreEANs": [
//           {
//             "DisplayName": String;
//             "EAN": String;
//           }
//         ],
//         "Description": String;
//         "Width": 0,
//         "Height": 0,
//         "Depth": 0,
//         "SizeUnit": 0,
//         "VATRate_ID": "stringstri"
// }
    
//     "Code": "string",
//     "PLU": 0,
//     "EAN": "string",
//     "Name": "string",
//     "ShortName": "string",
//     "ForeignName": "string",
//     "Specification": "string",
//     "Specification2": "string",
//     "StoreCardCategory_ID": "stringstri",
//     "Producer_ID": "stringstri",
//     "VATRate": 0,
//     "SpendingTaxTariff": 0,
//     "CustomsTariff": 0,
//     "Country_ID": "stringstri",
//     "Category": 0,
//     "Note": "",
//     "Comment": "string",
//     "SerialNumberStructure": "string",
//     "CustomsTariffNumber": "string",
//     "Hidden": true,
//     "StoreMenuItem_ID": "stringstri",
//     "DealerDiscount_ID": "stringstri",
//     "QuantityDiscount_ID": "stringstri",
//     "MainUnitCode": "strin",
//     "IsScalable": true,
//     "IsProduct": true,
//     "PrefixCode": "string",
//     "BodyCode": "string",
//     "SuffixCode": "string",
//     "MainSupplier_ID": "stringstri",
//     "MainUnitRate": 0,
//     "Picture_ID": {
//       "DisplayName": "string",
//       "ID": "string",
//       "ClassID": "string",
//       "ObjVersion": 0,
//       "BlobData": "string",
//       "PictureTitle": "string",
//       "ExternalFile": true,
//       "PathAndFileName": "string",
//       "RefCount": 0,
//       "IsProtected": true,
//       "Class_ID": "string",
//       "Class_Name": "string"
//     },
//     "ExpirationDue": 0,
//     "WithContainers": true,
//     "AuthorizedBy_ID": "stringstri",
//     "AuthorizedAt$DATE": "2024-02-01T09:04:56.763Z",
//     "VATRate_ID": "stringstri",
//     "VATRates": [
//       {
//         "DisplayName": "string",
//         "ID": "string",
//         "ClassID": "string",
//         "ObjVersion": 0,
//         "Parent_ID": "stringstri",
//         "Country_ID": "stringstri",
//         "VATRate_ID": "stringstri"
//       }
//     ],
//     "IntrastatInputStatistic_ID": "stringstri",
//     "IntrastatOutputStatistic_ID": "stringstri",
//     "IntrastatCommodity_ID": "stringstri",
//     "IntrastatUnitCode": "strin",
//     "IntrastatUnitRate": 0,
//     "IntrastatUnitRateRef": 0,
//     "IntrastatExtraType_ID": "stringstri",
//     "IntrastatWeight": 0,
//     "IntrastatWeightUnit": 0,
//     "OutOfStockDelivery": 0,
//     "OutOfStockBatchDelivery": 0,
//     "UseOutOfStockDelivery": true,
//     "UseOutOfStockBatchDelivery": true,
//     "DiscountsExcluded": true,
//     "IntrastatRegion_ID": "stringstri",
//     "StoreBatchStructure_ID": "stringstri",
//     "StoreAssortmentGroup_ID": "stringstri",
//     "UsualGrossProfit": 0,
//     "ToleranceType": 0,
//     "TolerancePlus": 0,
//     "ToleranceMinus": 0,
//     "IntrastatCurrentPrice": 0,
//     "IntrastatCurrentPriceLimit": 0,
//     "Pictures": [
//       {
//         "DisplayName": "string",
//         "ID": "string",
//         "ClassID": "string",
//         "ObjVersion": 0,
//         "Parent_ID": "stringstri",
//         "PosIndex": 0,
//         "Picture_ID": {
//           "DisplayName": "string",
//           "ID": "string",
//           "ClassID": "string",
//           "ObjVersion": 0,
//           "BlobData": "string",
//           "PictureTitle": "string",
//           "ExternalFile": true,
//           "PathAndFileName": "string",
//           "RefCount": 0,
//           "IsProtected": true,
//           "Class_ID": "string",
//           "Class_Name": "string"
//         }
//       }
//     ],
//     "GuaranteeLength": 0,
//     "GuaranteeUnitName": "string",
//     "GuaranteeLengthCorporate": 0,
//     "GuaranteeUnitNameCorporate": "string",
//     "MOSSService_ID": "stringstri",
//     "DRCArticles": [
//       {
//         "DisplayName": "string",
//         "ID": "string",
//         "ClassID": "string",
//         "ObjVersion": 0,
//         "Parent_ID": "stringstri",
//         "Country_ID": "stringstri",
//         "DRCVATMode": true,
//         "DRCArticle_ID": "stringstri",
//         "DRCArticleUnitRate": 0,
//         "DRCArticleUnitRateRef": 0,
//         "DRCArticleQUnit": "string"
//       }
//     ],
//     "IncomeType_ID": "stringstri",
//     "Priority": 0,
//     "NonStockType": true,
//     "EtalonUnit": "strin",
//     "EtalonRate": 0,
//     "WasteAmount": 0,
//     "WasteUnit": 0,
//     "WasteCategory_ID": "stringstri",
//     "OSSSupplyType": 0,
//     "CreatedAt$DATE": "2024-02-01T09:04:56.763Z",
//     "CorrectedAt$DATE": "2024-02-01T09:04:56.763Z",
//     "CreatedBy_ID": "stringstri",
//     "CorrectedBy_ID": "stringstri",
//     "X_Interpret_ID": "stringstri",
//     "X_DateOfPublication": "2024-02-01T09:04:56.763Z",
//     "X_Publisher_ID": "stringstri",
//     "X_Price": 0,
//     "X_DateOfRecording": "2024-02-01T09:04:56.763Z",
//     "X_OldEshop_ID": 0,
//     "X_LastUpdated$DATE": "2024-02-01T09:04:56.763Z",
//     "X_OrigPrice": 0,
//     "X_SLUG": "string",
//     "X_WorkFlow_ID": "string",
//     "X_Quantity": 0,
//     "X_LastPurchasePrice": 0,
//     "X_LastPurchase$DATE": "2024-02-01T09:04:56.763Z",
//     "X_StoreCardState_ID": "stringstri",
//     "X_PublishEshop": true,
//     "X_Genre": "stringstri",
//     "X_ThumbImage": "",
//     "X_ThumbUrl": "string",
//     "X_CoverImageUrl": "string",
//     "X_ResourceUrl": "string",
//     "X_TrackList": "stringstri",
//     "X_DiscogsUri": "string",
//     "X_CoverNumbers": "string",
//     "X_LastSale$DATE": "2024-02-01T09:04:56.763Z",
//     "X_LastSalePrice": 0,
//     "X_OldEshopWorkflowState": 0,
//     "X_PackNumber": "string",
//     "X_Country": "string",
//     "X_Title": "string"

// }

class StorecardService {
  getAll(params = {}) {
    // return http.get(ApiModule, { params });
    if (params.availableonstore) {
      console.log('params.availableonstore: ', params.availableonstore);
      querySearch.where = ("Hidden = false and StoreCardCategory_ID = '1000000101' and X_Quantity > 0");
    } else {
      querySearch.where = ("Hidden = false and StoreCardCategory_ID = '1000000101'");
    }
    console.log('querySearch: ', querySearch);
    return axios.post(config.API_URL+'/query', querySearch, { headers: authHeader() })
    .then(response => response.data)
      .catch(error => {
        console.error('Error fetching storecards:', error);
        throw error;
      });
  }

  getDiscounts() {
    querySearch.where = ("Hidden = false and StoreCardCategory_ID = '1020000101'");
    return axios.post(config.API_URL+'/query', querySearch, { headers: authHeader() });
  }

  getStoreMovements(id) {
    return axios.get(config.API_URL+`/script/API/StoreCards/GetStoreCardMovements?STORECARD=${id}`, { headers: authHeader() });
  }

  get(id) {
    // return axios.get(AbraApiModule+`/${id}`, { headers: authHeader() });
    querySearch.where = (`ID = '${id}'`);
    return axios.post(config.API_URL+'/query', querySearch, { headers: authHeader() })
  }

  create(data) {
    return axios.post(AbraApiModule, data, { headers: authHeader() });
  }

  update(id, data) {
    return axios.put(AbraApiModule+`/${id}`, data, { headers: authHeader() });
  }

  delete(id) {
    return axios.delete(AbraApiModule+`/${id}`, { headers: authHeader() });
  }

  getPictureFromAbra(id) {
    return axios.get(config.API_URL+`/script/API/StoreCards/GetPicture?STORECARD=${id}`, { headers: authHeader() });
  }

  getTrackListFromAbra(id) {
    return axios.get(config.API_URL+`/script/API/StoreCards/GetTrackList?STORECARD=${id}`, { headers: authHeader() });
  }

  searchDiscogsDatabase(searchType, searchQuery) {
    console.log('Start searchDiscogsDatabase with searchType: ', searchType);
    // if (searchType == 'barcode') {
      return axios.get(DiscogsApiModule+'?type=all', { params: { barcode: searchQuery, token: config.DISCOGS_API_TOKEN } });
    // }
  }

  getDiscogsRelease(releaseId) {
    console.log('Start getDiscogsRelease with releaseId: ', releaseId);
    return axios.get(config.DISCOGS_API_URL+`/releases/${releaseId}`, { params: { token: config.DISCOGS_API_TOKEN } });
  }

  searchAudio3(searchQuery) {
    console.log('Start searchAudio3 with searchQuery: ', searchQuery);
      return axios.get('http://www.audio3.cz/find.asp?', { params: { id: searchQuery } });
  }

  importFromDiscogs(data) {
    return axios.post(config.API_URL+'/script/API/StoreCards/StoreCard', data, { headers: authHeader() });
  }

}

export default new StorecardService();
